import { useContext, useState, useEffect } from "react";
import { OaRVaRD3Chart } from "../../../d3charts/oarvar/OaRVarD3Chart";
import { applyOverrides } from "../../../utils/dataFunctions";
import { LocalStoreContext } from "../store/LocalStore";
import { Loader } from "../../../components/loader/Loader";
import { config as chartConfig } from "../../../d3charts/oarvar/config";

const getPercentileHeader = (filter) => {
  return filter[" Pctile "].includes("All")
    ? "95 & 99%tile"
    : filter[" Pctile "].includes("95")
    ? "95%tile"
    : "99%tile";
};

const getHorizonHeader = (filter) => {
  return filter.Horizon.includes("All")
    ? "All trading day horizons"
    : `${filter.Horizon.filter((item) => item !== "All")
        .map((item) => +item)
        .sort()
        .map((item) => `${item.toFixed(0)}d`)
        .join(",")} trading day horizons`;
};

export const OaRVaRChartConfig = ({
  data,
  width,
  height,
  lRef,
  palette,
  selection,
}) => {
  const [lstore] = useContext(LocalStoreContext);
  const [config, setConfig] = useState();

  const { filter } = lstore;

  useEffect(() => {
    
    const oarvarConfig = applyOverrides(chartConfig, {
      axes: {
        y: {
          label: {
            text:
              selection === "VaR"
                ? "VaR (Value at Risk)"
                : "OaR (Opportunity at Risk)",
          },
          background: {
            selectedColor: chartConfig.axes.y.background.color[selection],
          },
        },
      },
      header: {
        text: `${getPercentileHeader(
          filter
        )} ${selection} vs. VScore, ${getHorizonHeader(filter)} `,
      },
    });
    setConfig(oarvarConfig);
  }, [selection, filter]);

  return config ? (
    <OaRVaRD3Chart
      data={data}
      width={width}
      height={height}
      config={config}
      lRef={lRef}
      palette={palette}
      selection={selection}
    />
  ) : (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader />
    </div>
  );
};
